function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 16"
}, props), React.createElement("path", {
  fill: "#4F566B",
  d: "M7.504 7.76c1.908 0 3.566-1.709 3.566-3.934C11.07 1.628 9.412 0 7.504 0 5.597 0 3.94 1.664 3.94 3.844c0 2.207 1.65 3.916 3.565 3.916zM13.093 16C14.5 16 15 15.6 15 14.816c0-2.295-2.879-5.463-7.504-5.463C2.879 9.353 0 12.52 0 14.816 0 15.6.5 16 1.898 16h11.195z"
})));